import React from 'react';
import {
  MainWrapper,
  SkeletonHeading,
  SkeletonWrapper,
  SkeletonImage,
  SkeletonContent,
  SkeletonLine,
  SkeletonButtonRow,
  SkeletonButton,
  SkeletonDots,
  Dot,
} from './SignatureChefContainerSkeleton.styles';
import { chefHighlight, signatureItems } from '../../modules/utils/constants/constants';

interface SignatureSkeletonProps {
  componentName?: string;
}

export const SignatureDishesSkeleton: React.FC<SignatureSkeletonProps> = ({ componentName }) => {
  const isChefHighlight = componentName === chefHighlight;
  const isSignature = componentName === signatureItems;
  const showButton = isChefHighlight || isSignature;
  const showDots = isSignature;

  return (
    <MainWrapper>
      <SkeletonHeading />
      <SkeletonWrapper>
        <SkeletonImage />
        <SkeletonContent>
          <SkeletonLine width="30%" />
          <SkeletonLine width="60%" />
          <SkeletonLine width="90%" />
          <SkeletonLine width="85%" />
          {showButton && (
            <SkeletonButtonRow>
              {isChefHighlight && <SkeletonButton />}
              {isSignature && (
                <>
                  <SkeletonButton />
                  <SkeletonButton />
                </>
              )}
            </SkeletonButtonRow>
          )}
        </SkeletonContent>
      </SkeletonWrapper>
      {showDots && (
        <SkeletonDots>
          <Dot />
          <Dot />
          <Dot />
          <Dot />
        </SkeletonDots>
      )}
    </MainWrapper>
  );
};
